package ru.villawonka.app.platform.platform.model

enum class PlatformType {
    TELEGRAM,
    IOS,
    ANDROID
}